import { AreaId } from '@gyym/sdk'

import { usePrefectures } from '@/modules/Prefectures'

import { useFacilitiesMeta } from './useFacilitiesMeta'

export const useFacilitiesMetaArea = (id?: AreaId) => {
  const { data } = useFacilitiesMeta()

  const metaArea = data?.prefectures
    .find((p) => p.areas.some((area) => area.id === id))
    ?.areas.find((area) => area.id === id)

  const shouldFetch = !!id && !metaArea
  const { data: prefectures } = usePrefectures(shouldFetch)

  const area = prefectures
    ?.find((p) => p.areas.some((area) => area.id === id))
    ?.areas.find((area) => area.id === id)

  return metaArea || area
}
